import { Colleague } from 'store/user/types'

const getFullName = (user: Colleague) => `${user.profile.firstName} ${user.profile.lastName}`

export default getFullName
